import { api } from '../api';

export interface Banner {
  id: number;
  title: string;
  image_desktop: string;
  image_mobile: string;
  link: string;
  sort_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateBannerData {
  title?: string;
  link?: string;
  sort_order?: number;
  image_desktop: File;
  image_mobile: File;
}

export interface UpdateBannerData {
  title?: string;
  link?: string;
  sort_order?: number;
  image_desktop?: File;
  image_mobile?: File;
}

function buildFormData(data: CreateBannerData | UpdateBannerData): FormData {
  const formData = new FormData();
  if (data.title !== undefined) formData.append('title', data.title);
  if (data.link !== undefined) formData.append('link', data.link);
  if (data.sort_order !== undefined) formData.append('sort_order', String(data.sort_order));
  if (data.image_desktop) formData.append('image_desktop', data.image_desktop);
  if (data.image_mobile) formData.append('image_mobile', data.image_mobile);
  return formData;
}

export const adminBannersApi = {
  getAll: async (): Promise<Banner[]> => {
    const response = await api.get<Banner[]>('/admin/banners');
    return response.data;
  },

  create: async (data: CreateBannerData): Promise<Banner> => {
    const formData = buildFormData(data);
    const response = await api.post<Banner>('/admin/banners', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      maxBodyLength: Infinity,
      maxContentLength: Infinity,
    });
    return response.data;
  },

  update: async (id: number, data: UpdateBannerData): Promise<Banner> => {
    const formData = buildFormData(data);
    const response = await api.put<Banner>(`/admin/banners/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      maxBodyLength: Infinity,
      maxContentLength: Infinity,
    });
    return response.data;
  },

  toggle: async (id: number, isActive: boolean): Promise<Banner> => {
    const response = await api.patch<Banner>(`/admin/banners/${id}/toggle`, {
      is_active: isActive,
    });
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/admin/banners/${id}`);
  },
};

// Публичный API
export const bannersApi = {
  getActive: async (): Promise<Banner[]> => {
    const response = await api.get<Banner[]>('/banners');
    return response.data;
  },
};
